export default __webpack_public_path__ + "static/media/webinar-1536x528.17c4f070.png";